<template>
<Card :padding="0" :headClass="headClass" :extraClass="extraClass">
    <p v-if="showTitle" slot="title" :style="pStyle" @click="toggle" >
        <span :class="titleClass" v-text="myConfig.title" /> <Icon v-if="myConfig.hide" class="efuture-title-icon" :style="iconStyle" type='ios-arrow-forward'/> 
    </p>
    <div v-show="showGrid" :style="cardStyle" >
         <ViewGrid ref="grid" :config="myConfig"></ViewGrid>
    </div>
</Card>
</template>
<script>
export default {
    name: 'operlog',
    data () {
        return {
            myConfig:{
                hide:true,
                headStyle:'',
                titleType:1,
                dynamicHeight:true,
                method:'OperLogSrv.search',
                searchParam:{
                    order_field: 'operdate',
                    order_direction: 'desc'
                },
                response:'operation_log',
                title:'操作日志',
                height:2500,
                items:[{
                    label:'操作类型',
                    name:'opertype',
                    type:'ComboBox',
                    data:[{
                        code:'U',name:'修改'
                    }, {
                        code:'I',name:'新增'
                    }, {
                        code:'D',name:'删除'
                    }],
                    codeWithName:false,
                    width:80
                },{
                    label:'操作日期',
                    name:'operdate',
                    type:'DateBox',
                    vtype:'datetime',
                    width:150
                }, {
                    label:'操作人',
                    name:'username',
                    type:'TextBox',
                    width:150
                }, {
                    label:'操作内容',
                    name:'memo',
                    type:'TextBox',
                    tooltip:true
                }]
            },
            cardPadding:0,
            cardStyle:'',
            showGrid:true,
            showTitle:true,
            pStyle:'',
            iconStyle:'',
            bussinesscode:''
        };
    },
    created() {
        this.myConfig.resources = this.config.resources;
        this.myConfig.tableSize = 'small';
        this.myConfig.titleType = this.config.titleType;
        this.myConfig.showBorder = false;
        // 处理模块号提示
        let modulecode = this.$Method.getUrlParam('modulecode');
        if (!modulecode) {
            modulecode = this.$Method.getUrlParam('billmoduleid');
        }
        if (this.modulecode) {
            modulecode = this.modulecode;
        }
        this.myConfig.searchParam.billmoduleid = modulecode;
        this.myConfig.refurbishCheck = this.refurbishCheck;
        this.customInit ();
        this.showGrid = true;
        this.setTitleStyle();
    },
    computed: {
        titleClass () {
            return `efuture-title-font-${this.myConfig.titleType}`;
        },
        headClass () {
            if (!this.showGrid) {
                return `efuture-card-head-title-${this.myConfig.titleType}` + ' efuture-card-head-title-nobottom';
            } else {
                return `efuture-card-head-title-${this.myConfig.titleType}`;
            }
        },
        extraClass () {
            return `efuture-card-extra-title-${this.myConfig.titleType}`;
        }
    },
    props:{
        config: {
            type:Object,
            default:null
        },
        modulecode: {
            type:String,
            default:null
        }
    },
    methods: {
        customInit() {
            if (this.myConfig.hide) {
                this.pStyle = 'cursor:pointer';
                this.iconStyle = 'transform: rotate(90deg)';
            } 
            this.cardPadding = 5 * Number(this.myConfig.titleType);
            this.cardStyle = 'padding-left:'+this.cardPadding+'px;padding-right:'+this.cardPadding+'px;padding-bottom: 10px;';
        },
        toggle () {
            if (this.myConfig.hide) {
                this.showGrid = !this.showGrid;
                this.setTitleStyle();
            }
        },
        setShowGrid(value) {
            this.showGrid = value;
            this.setTitleStyle();
        },
        setTitleStyle () {
            if (this.showGrid) {
                this.iconStyle = 'transform: rotate(90deg)';
                this.cardPadding =  5 * Number(this.myConfig.titleType);
                this.cardStyle = 'padding-left:'+this.cardPadding+'px;padding-right:'+this.cardPadding+'px;padding-bottom: 10px;';
            } else {
                this.iconStyle = '';
                this.cardPadding  = 0;
                this.cardStyle = '';
            }
        },
        refurbishCheck (para,old,toDo) {
            if (this.bussinesscode) {
                toDo(true,para,old);
            } else {
                toDo(false,para,old);
            }
        },
        refurbish (value) {
            if (value) {
                let para = {};
                para.bussinesscode = value;
                this.bussinesscode = value;
                this.$refs.grid.clearSearchBeforeSearchParam();
                this.$refs.grid.setSearchBeforeSearchParam(para);
                this.$refs.grid.refurbish();
            } else {
                this.bussinesscode = '';
                this.$refs.grid.clearSearchBeforeSearchParam();
                this.$refs.grid.clearData();
            }
        },
        clearData () {
            this.$refs.grid.clearData();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/layouttemplate/operlog.vue